import { render, staticRenderFns } from "./ExceptionPost.vue?vue&type=template&id=6fbaa870&scoped=true&"
import script from "./ExceptionPost.vue?vue&type=script&lang=ts&"
export * from "./ExceptionPost.vue?vue&type=script&lang=ts&"
import style0 from "./ExceptionPost.vue?vue&type=style&index=0&id=6fbaa870&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbaa870",
  null
  
)

export default component.exports